import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { WatchlistBaseModel } from '../../domain/watchlist/WatchlistDomains';

export type WatchlistActions = 'CHANGE_DATA_WATCHLIST' | 'CLEAR_WATCHLIST';

export const changeWatchlist = (payload: WatchlistBaseModel | null) =>
  ({
    type: 'CHANGE_DATA_WATCHLIST',
    payload,
  }) as ReduxBaseAction<WatchlistBaseModel | null, WatchlistActions>;

export const clearWatchlist = () =>
  ({
    type: 'CLEAR_WATCHLIST',
    payload: void 0,
  }) as ReduxBaseAction<void, WatchlistActions>;
